import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { attemptTokenRefresh, clearAuthAndRedirect } from "../../../utils/authUtils";

const PrivateRoute = ({ children }) => {
  const [authState, setAuthState] = useState(null); // null=checking, true=valid, false=invalid
  const currentPath = window.location.pathname;
  const ukWebsiteUrl = process.env.REACT_APP_UK_WEBSITE_URL;
  const userLoginUrl = `${ukWebsiteUrl}/login_email`;
  const isUserRoute = currentPath.includes("/user");

  const redirectToLogin = () => {
    window.location.href = userLoginUrl;
    return null;
  };

  useEffect(() => {
    const token = localStorage.getItem("access_token_admin");

    if (!token) {
      setAuthState(false);
      return;
    }

    try {
      const decoded = jwtDecode(token);
      const isExpired = decoded.exp < Date.now() / 1000;

      if (!isExpired) {
        setAuthState(true);
        return;
      }

      // Token expired — attempt silent refresh before redirecting
      attemptTokenRefresh()
        .then(() => setAuthState(true))
        .catch(() => clearAuthAndRedirect());
    } catch {
      localStorage.clear();
      setAuthState(false);
    }
  }, []);

  if (authState === null) return null;
  if (!authState) {
    return isUserRoute ? redirectToLogin() : <Navigate to="/admin-login" replace />;
  }
  return children;
};

export default PrivateRoute;
